export default {
  // vuex state
  // pageTitle: ''
}
